/* Behavior - behaviors/slide.js */

$(function () {
    var $testimonials = $('.sec-testimonials .owl-carousel');

    if(!$testimonials.length) return

    $testimonials.owlCarousel({
        items: 1,
        autoplay: false,
        loop: false,
        navContainer: $('.sec-testimonials .slide-navs_inner'),
        rewind: true,
        dots: false,
        nav: true,
        // margin: 30,
        navElement: 'span',
        navText : ['<span><span>Anterior</span></span>','<span><span>Próximo</span></span>'],
        navSpeed: 500,
        dotsSpeed: 500,
        dragEndSpeed: 500,
        autoplaySpeed: 500,
        autoplayTimeout: 6000,       
    });

    var $testimonialsNavs = $('.sec-testimonials .slide-navs_inner.disabled');
    
    if(!$testimonialsNavs.length) return
    $('.sec-testimonials .slide-navs').addClass('disabled');
});